module.exports = __webpack_public_path__ + "img/dmz.be2215a.svg";